
(function() {
  var result = { translations: { "en": null } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "signup-ui-lego": {
    "da": "static-1.9882",
    "de": "static-1.9882",
    "en": "static-1.9882",
    "es": "static-1.9882",
    "fi": "static-1.9882",
    "fr": "static-1.9882",
    "it": "static-1.9882",
    "ja": "static-1.9882",
    "nl": "static-1.9882",
    "no": "static-1.9882",
    "pl": "static-1.9882",
    "pt-br": "static-1.9882",
    "sv": "static-1.9882",
    "zh-tw": "static-1.9882"
  }
};
  hns('I18n', result);

})();


